import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { BookingModel, BookingService } from 'src/app/Api_Module';
import { MediatorService } from 'src/app/services/mediator.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'crg-viewbookings',
  templateUrl: './viewbookings.component.html'
})
export class ViewbookingsComponent implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  filtervalue;

  bookings: BookingModel[] = [];
  cache: BookingModel[] = [];
  searchDate: Date;
  alert: any;
  loading: boolean;

  messages = {emptyMessage: 'No Bookings found. Try different parameters', totalMessage: 'Total Bookings'};

  constructor(private bookingService: BookingService, private mediator: MediatorService,
    private router: Router, private toastr: ToastrService) { }

  ngOnInit() {
    this.searchDate = new Date();
    this.viewBookings();
  }

  viewBookings(): void {
    this.loading = true;
    console.log('Searching: ' + this.searchDate);
    this.bookingService.getBookings(this.dateToString(this.searchDate)).subscribe( resp => {
      this.loading = false;
      this.cache = [ ... resp];
      this.bookings = [ ... resp]
      .sort((a: BookingModel, b: BookingModel) => {
        if (new Date(b.checkout) > new Date(a.checkout)) {
            return 1;
        }
        if (new Date(b.checkout) < new Date(b.checkout)) {
          return -1;
        }
        return 0;
      });
      this.alert = {type: 'success', message: 'Found ' + this.bookings.length + ' bookings.'};
    },
    error => {
      this.loading = false;
      this.alert = {type: 'danger', message: 'Something went wrong, please try again later.'};
      console.log('erro:' + JSON.stringify(error));
  });
  }

  viewABooking(booking: BookingModel) {
    this.mediator.selectedBooking(booking);
    this.router.navigate([ 'view/booking' ], {queryParams: {action: 'checkout'}});
  }

  checkin(booking) {
    this.loading = true;
      this.bookingService.checkIn(booking.bookingId).subscribe(resp => {
        this.loading = false;
        this.toastr.success('Check In Complete');
        this.viewBookings();
      },
        error => {
          this.loading = false;
          this.toastr.error('Something went wrong please try again later!');
          console.log('error:' + JSON.stringify(error));
        });
  }

  printInvoice(bookingId) {
    let popupWin;
    popupWin = window.open(`${this.bookingService.configuration.basePath}/api/Booking/${bookingId}/invoice`,
    '_blank', 'top=0,left=0,height=100%,width=auto');
  }
  printConfirmation(reference) {
    let popupWin;
    popupWin = window.open(`${this.bookingService.configuration.basePath}/api/Report/${reference}/confirmationReport`,
      '_blank', 'top=0,left=0,height=100%,width=auto');
  }

  private dateToString(date: Date): string {
    const day = date.getDate();
    const monthIndex = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours();
    const munites = date.getMinutes();
    const datestr = `${year}-${monthIndex < 10 ?  '0' + monthIndex : monthIndex}-${day < 10 ?  '0' + day : day}`;
    console.log(datestr);
    return datestr;
  }

  updateFilter(event) {
    const val = this.filtervalue;

    if (val) {
        // filter our data
      const aVal  = val.toLowerCase();
      const temp = this.bookings.filter(function(d) {
      return (d.reference && d.reference.toLowerCase().indexOf(aVal) !== -1) ||
      (d.registration && d.registration.toLowerCase().indexOf(aVal) !== -1) ||
      (d.name && d.name.toLowerCase().indexOf(aVal) !== -1) ||
      (d.surname && d.surname.toLowerCase().indexOf(aVal) !== -1) || !aVal;
    });

    // update the rows
    this.bookings = temp;
    } else {
      this.bookings = [... this.cache];
    }
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  clearFilter() {
    this.filtervalue = '';
    this.bookings = [... this.cache];
  }

  close(alert: any) {
    this.alert = null;
  }
}
